/**
 * O formulário das novidades, no rodapé.
 *
 * A regra é a mesma do resto da loja: quem decide é o servidor. O `required`
 * do campo não conta para nada — quem chamar a API directamente não passa por
 * ele — por isso o e-mail é validado outra vez em
 * `cybershop.loja.subscricao.subscrever`, que é também quem trava o abuso.
 *
 * Aqui só se trata de não deixar a pessoa sem resposta: o botão bloqueia
 * enquanto o pedido corre, e a mensagem que aparece é a que o servidor
 * mandou.
 */
(function () {
	"use strict";

	const METODO = "cybershop.loja.subscricao.subscrever";

	function responder(caixa, texto, erro) {
		if (!caixa) return;
		caixa.textContent = texto;
		caixa.classList.toggle("erro", !!erro);
	}

	function ligar() {
		const forma = document.querySelector("[data-ct-subscrever]");
		if (!forma) return;

		const campo = forma.querySelector('input[type="email"]');
		const botao = forma.querySelector("button");
		const caixa = document.querySelector("[data-ct-subscrever-resposta]");

		forma.addEventListener("submit", function (e) {
			e.preventDefault();

			const email = (campo.value || "").trim();
			if (!email) {
				responder(caixa, __("Escreva o seu e-mail."), true);
				campo.focus();
				return;
			}

			botao.disabled = true;
			responder(caixa, __("A registar…"), false);

			// `Promise.resolve` porque o frappe.call devolve uma promessa do
			// jQuery, que não tem `.finally` — ver o comentário longo em
			// public/js/carrinho.bundle.js.
			Promise.resolve(
				frappe.call({ method: METODO, args: { email: email }, type: "POST" })
			)
				.then((r) => {
					responder(caixa, (r.message && r.message.mensagem) || __("Obrigado!"), false);
					campo.value = "";
				})
				.catch((erro) => {
					const msg =
						(erro && erro._server_messages) ||
						(erro && erro.message) ||
						"";
					responder(
						caixa,
						/Rate|limit|Too many/i.test(String(msg))
							? __("Demasiadas tentativas. Tente daqui a pouco.")
							: __("Não foi possível registar. Verifique o e-mail."),
						true
					);
				})
				.finally(() => {
					botao.disabled = false;
				});
		});

		// A ligação da barra de apoio leva ao campo — e põe lá o cursor, que é
		// o que a pessoa quer. Um `href` para uma âncora rola até lá mas não
		// dá foco a um campo de texto.
		const atalho = document.querySelector("[data-ct-ir-para-subscrever]");
		if (atalho) {
			atalho.addEventListener("click", function (e) {
				e.preventDefault();
				campo.scrollIntoView({ block: "center", behavior: "smooth" });
				campo.focus({ preventScroll: true });
			});
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", ligar);
	} else {
		ligar();
	}
})();

/**
 * Rodapé no telemóvel: «Links úteis» e «Contacte-nos» abrem e fecham.
 *
 * Porquê: a uma coluna, o rodapé aberto ocupava quase dois ecrãs. É o que
 * a NCR faz bem (proposta aprovada a 15-09-2026). O HTML do rodapé vem do
 * `catalogo/rodape.py` e não muda — o título de cada coluna passa a botão só
 * enquanto o ecrã for de telemóvel. No computador fica tudo aberto e sem
 * papel de botão, porque não há nada para abrir.
 */
(function () {
	"use strict";

	const MOVEL = window.matchMedia("(max-width: 576px)");

	function ligar() {
		document
			.querySelectorAll(".ct-rodape-coluna:not(.ct-rodape-novidades) > h4")
			.forEach((titulo, i) => {
				const lista = titulo.nextElementSibling;
				const coluna = titulo.parentElement;
				if (!lista) return;
				if (!lista.id) lista.id = "ct-rodape-lista-" + i;

				const acertar = () => {
					if (MOVEL.matches) {
						titulo.setAttribute("role", "button");
						titulo.setAttribute("tabindex", "0");
						titulo.setAttribute("aria-controls", lista.id);
						titulo.setAttribute("aria-expanded", String(coluna.classList.contains("ct-aberta")));
					} else {
						["role", "tabindex", "aria-controls", "aria-expanded"].forEach((a) => titulo.removeAttribute(a));
					}
				};
				const alternar = () => {
					if (!MOVEL.matches) return;
					coluna.classList.toggle("ct-aberta");
					acertar();
				};

				titulo.addEventListener("click", alternar);
				titulo.addEventListener("keydown", (e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						alternar();
					}
				});
				MOVEL.addEventListener("change", acertar);
				acertar();
			});
	}

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ligar);
	else ligar();
})();
